export const APP_CONFIG = {
  NAME: "Maximum Loan Calculator",
  VERSION: "1.0.0",
  DESCRIPTION: "A comprehensive maximum loan calculator with real-time calculations, stress testing, and admin management",
  COMPANY: "Market Harborough Building Society",
} as const;

// Feature flags
export const FEATURE_FLAGS = {
  // Set to true to restore sign-in functionality
  ENABLE_SIGN_IN: true,
} as const;

export const ROUTES = {
  CALCULATOR: "CALCULATOR",
  RESULTS: "RESULTS", 
  ADMIN: "ADMIN",
  PRIVACY: "PRIVACY",
} as const;

